import React, { useState, useContext, useEffect, useRef } from 'react';
import { CircularProgress,TextField, IconButton, Box } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import ClearIcon from '@mui/icons-material/Clear';
import { ModeContext } from './ModeContext';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import CancelIcon from '@mui/icons-material/Cancel';
import { BlobServiceClient } from '@azure/storage-blob';
const ChatInput = ({ onSubmitMessage, onSearch ,onSubmit}) => {
    const inputRef = useRef(null);
    const [title, setTitle] = useState('');
    const [loading, setLoading] = useState(false);
    const [imageData, setImageData] = useState(null);
    const { mode, messages, setMessages,
    isComplete,setIsComplete, input, setInput,
    loginInfo, setLoginInfo} = useContext(ModeContext);

    const fileInputRef = useRef(null);
    const [imageFile, setImageFile] = useState(null); // Fileオブジェクト
    const [blobUrl, setBlobUrl] = useState(null);     // 表示用BlobのURL

    //useEffect(() => {
        // キャッシュからタイトルを読み込む
    //    loadFromCache('chat-history-cache', sessionId).then(result => {
    //        setTitle(result.length === 0 ? input : result.title);
    //    });
    //}, [input, sessionId]);

//    useEffect(() => {
//        const lastMsg = messages[messages.length - 1];
//        if (lastMsg?.sender !== 'user') {
//            setIsComplete(true); // 回答完了
//        }
//    }, [messages]);
    

    useEffect(() => {
        const isDisabled = !isComplete && mode !== 'faq';
        if (!isDisabled && inputRef.current) {
            const inputElem = inputRef.current;
    
            // フォーカスしてカーソルを最上部に移動
            inputElem.focus();
    
            // マルチラインの時、カーソル位置を先頭に設定
            if (inputElem.setSelectionRange) {
                inputElem.setSelectionRange(0, 0);
            }
        }
    }, [isComplete, mode]);


    const handleSubmit = async (e) => {
        try {
            e?.preventDefault();

            if (!input.trim() && !imageData) return;
            setIsComplete(false)

            let uploadedUrl = null;
            if (imageFile) {
                uploadedUrl = await uploadToBlob(imageFile);
                setBlobUrl(uploadedUrl);
            }
            setLoading(true);
            let resultText
            if (uploadedUrl){
                const requestData = {
                    action:'search',
                    filename:uploadedUrl
                }
                if (mode !== 'sendbak' && mode !== 'support') {
                    const response = await fetch('https://sp-blobfileupcunk-h0d8babfg4e4cscm.japaneast-01.azurewebsites.net/api/http_trigger', {
                    method: 'POST', // ← POSTメソッドで送信
                    headers: {
                    'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(requestData)
                });
                resultText = await response.text(); 
                }
            }

            const inputMessage = {
                sender: 'user',
                text: uploadedUrl ? `<a href='${uploadedUrl}' target='_blank' rel='noopener noreferrer'>画像情報</a> ${input}` : input,
                mode,
                image: `${uploadedUrl}` || null, // base64ではなくBlob URL
                imagemessage:resultText
            };
            //<a href='https://spstrage.blob.core.windows.net/faq/100001/image/1761621880222-AW-5600.png?sp=racwd&st=2025-04-03T06:48:52Z&se=2045-04-03T14:48:52Z&spr=https&sv=2024-11-04&sr=c&sig=pQe4IYIUaD0kZbfDWqhaG7M3ps7rn5dCxurv5vrpf3w%3D'>画像情報</a>
            setLoading(false); 

            setInput('');
            setImageData(null);
            setImageFile(null);
            onSubmit(null, inputMessage, '');
            //const uploadedUrl = await uploadToBlob(imageFile);
            //setBlobUrl(uploadedUrl); // 表示用に保存
            // 必要なら setImageFile(null); なども
        } catch (err) {

            alert('画像のアップロードに失敗しました。\n質問を入力してください。')
            setLoading(false);
            setIsComplete(true); 

            handleRemoveImage()
            console.error("アップロード失敗:", err);
        }

    };


    const uploadToBlob = async (file) => {
        const containerSasUrl=`${process.env.REACT_APP_BLOB3_URL}?${process.env.REACT_APP_BLOB3_TOKEN}`;
        console.log('SASurl',containerSasUrl)
        const blobName = `${loginInfo.compId}/image/${Date.now()}-${imageFile.name}`;
        const containerClient = new BlobServiceClient(containerSasUrl).getContainerClient('');
        const blobClient = containerClient.getBlockBlobClient(blobName);
        await blobClient.uploadData(file, {
            blobHTTPHeaders: { blobContentType: file.type }
        });

        const uploadedUrl = `${process.env.REACT_APP_BLOB3_URL}/${blobName}?${process.env.REACT_APP_BLOB3_TOKEN}`;

        setBlobUrl(uploadedUrl); // 表示用URL

        return uploadedUrl;
    };

    const handleImageCapture = (event) => {
        const file = event.target.files[0];
        console.log('ImageCapture',file)
        event.target.value = null; // 同じファイルでも次回onChangeが発火するように
        if (!file) return;

        if (!file.type.startsWith('image/')) {
            console.warn('画像ファイルではありません:', file.type);
            return;
        }
        setImageFile(file);

        const reader = new FileReader();
        reader.onloadend = () => {
            setImageData(reader.result);
        };
        reader.readAsDataURL(file);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSubmit(e);
        }
    };

    const handleClear = () => {
        setInput('');
        setImageData(null);
    };

    const handleRemoveImage = () => {
        setImageFile(null);
        setImageData(null);
    };



    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onloadend = () => {
            setImageData(reader.result); // プレビュー用
        };
        reader.readAsDataURL(file);
    };

    return (
        <form className="chat-input-child" onSubmit={handleSubmit}>
            <Box sx={{ position: 'relative', width: '100%' }}>
            {imageData && (
                <Box
                sx={{
                    position: 'absolute',
                    top: 4,
                    left: 4,
                    maxHeight: 40,
                    maxWidth: 40,
                    zIndex: 1,
                }}
                >
              
                <img
                    src={imageData}
                    alt="preview"
                    style={{ maxHeight: '100%', maxWidth: '100%', borderRadius: '4px' }}
                />
                <div style={{ textAlign: 'right' }}>
                <IconButton
                    onClick={handleRemoveImage}
                    size="small"
                            sx={{
                            top: '-12px',
                            right: '-6px',
                            backgroundColor: 'rgba(255,255,255,0.7)',
                            padding: '2px',
                            zIndex: 2,
                            '&:hover': {
                                backgroundColor: 'rgba(56, 55, 55, 0.2)',
                            },
                        }}
                    >
                    <CancelIcon fontSize="small" />
                </IconButton>
                </div>

                </Box>
                
            )}
            <TextField
                inputRef={inputRef}
                variant="outlined"
                fullWidth
                value={input}
                onChange={(e) => setInput(e.target.value)}
                placeholder="質問してください。"
                size="small"
                multiline
                disabled={!isComplete && mode !== 'faq'}
                InputProps={{
                sx: {
                    paddingLeft: imageData ? '60px' : '14px', // 画像があるときは左に余白
                    backgroundColor: 'white',
                    fontSize: '14px',
                    minHeight: '102px', // 最小高さを設定
                    maxHeight: '102px', // 最大高さを固定
                    alignItems: 'flex-start',
                    overflow: 'hidden', // 外側のoverflowを非表示
                    '& .MuiInputBase-input': {
                        maxHeight: '86px', // 内部テキストエリアの最大高さ（パディング分を考慮）
                        overflowY: 'auto', // 縦スクロールを有効化
                        boxSizing: 'border-box',
                    }
                }
                }}
                onKeyDown={handleKeyDown}
            />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}>

            <IconButton
                color="secondary"
                onClick={handleSubmit}
                disabled={!isComplete} // loading を加える false非表示
                size="small"
            >
                {loading ? ( 
                    <CircularProgress size={20} /> // 送信中は砂時計
                ) : (
                    <SendIcon sx={{ fontSize: '20px' }} />
                )}
            </IconButton>

                <IconButton color="primary" component="label" disabled={!isComplete} size="small">
                    <PhotoCameraIcon sx={{ fontSize: '20px' }}  />
                    <input type="file" accept="image/*" capture="environment" hidden onChange={handleImageCapture} />
                </IconButton>
{/*
                <IconButton color="secondary" onClick={handleSearchdev}  size="small">
                    <SendIcon sx={{ fontSize: '20px' }} />
                </IconButton>
*/}
                <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/*"
                    capture="environment"
                    style={{ display: 'none' }}
                    onChange={handleImageChange}
                />

                <IconButton color="default" onClick={handleClear}  disabled={!isComplete} aria-label="clear" size="small">
                    <ClearIcon sx={{ fontSize: '20px' }} />
                </IconButton>

            </Box>
        </form>
    );
};

export default ChatInput;
　